import loadable from "@loadable/component";
import AEMWrapper from "aem/ComponentWrapper";
import React from "react";
import meta from "./aem-meta";

const Component = loadable(
  () =>
    import(
      /* webpackChunkName: "component-accordion/aem-component" */ "./aem-component"
    ),
  {
    fallback: <></>
  }
);

export default AEMWrapper(meta, Component);
